'use client';

import { useAuth } from '@/contexts/AuthContext';
import LegalAcknowledgementModal from '@/components/LegalAcknowledgementModal';

export default function LegalModalWrapper() {
  const { user, showLegalModal, dismissLegalModal } = useAuth();

  if (!showLegalModal || !user) return null;

  return (
    <LegalAcknowledgementModal
      userId={user?.id}
      onAccepted={dismissLegalModal}
    />
  );
}
